import { JetView } from "webix-jet";
import Toolbar from "./toolbar";

import { createState } from "jet-restate";

export default class UsersView extends JetView {
	config() {
		const _ = this.app.getService("locale")._;
		this.Compact = this.getParam("compact", true);
		this.setParam(
			"state",
			createState({ mode: "grid", name: _("Users"), search: "" })
		);

		return {
			margin: 10,
			padding: 10,
			css: "webix_um_tableview",
			cols: [
				{
					rows: [
						Toolbar,
						{
							$subview: true,
							name: "center",
						},
					],
				},
				{ $subview: "_hidden", name: "default" },
			],
		};
	}

	init() {
		this.on(this.getParam("state").$changes, "mode", v => {
			let path = "users." + v;
			if (v === "matrix" && !this.app.config.roles) path = "users.rulematrix";
			this.show(path, { target: "center" });
			if (v === "matrix") {
				this.setParam("id", null);
				this.show("./_hidden");
			}
		});
	}

	ShowDetails(id) {
		const now = this.getParam("id");
		const next = id.toString();

		if (this.getParam("compact", true) || !now) {
			this.app.callEvent("details:item-click", ["users", next]);
		} else if (now !== next) {
			this.setParam("id", next, true);
		}
	}

	HideEditor() {
		if (this.Compact) {
			this.show("../users/_hidden");
		} else {
			this.show("users.details");
		}
	}
}
